import React, { useEffect } from 'react';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import ImageUpload from '../common/ImageUpload';

const BuiltForm = ({ data, onChange, submitted }) => {
  useEffect(() => {
    if (data.length !== 5) {
      const newData = [...data];
      while (newData.length < 5) {
        newData.push({ title: "", description: "", image: "" });
      }
      if (newData.length > 5) {
        newData.splice(5);
      }
      onChange(newData);
    }
  }, [data.length, onChange]);

  const handleChange = (index, field, value) => {
    onChange((prev) => {
      const newData = [...prev];
      newData[index] = { ...newData[index], [field]: value };
      return newData;
    });
  };

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center border-b pb-4">
        <Label className="text-xl font-bold">Built Section (Fixed 5 Steps) <span className="text-red-500">*</span></Label>
        <span className="text-xs text-slate-500 bg-slate-100 px-3 py-1 rounded-full font-medium">All 5 steps are required</span>
      </div>

      <div className="grid grid-cols-1 gap-8">
        {data.map((item, index) => (
          <div
            key={index}
            className={`bg-white p-6 rounded-3xl border shadow-sm transition-all ${submitted && (!item.title || !item.description || !item.image) ? "border-red-500 shadow-red-50" : "border-slate-200"}`}
          >
            <div className="flex items-center gap-3 mb-6">
              <span className="bg-primary text-white w-8 h-8 rounded-full flex items-center justify-center font-bold text-sm shadow-sm shadow-primary/20">
                {index + 1}
              </span>
              <h3 className="font-bold text-slate-800">Step {index + 1}</h3>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="space-y-4">
                <div className="space-y-2">
                  <Label>Step Title <span className="text-red-500">*</span></Label>
                  <Input
                    value={item.title}
                    className={(!item.title && submitted) ? "border-red-500" : ""}
                    onChange={(e) => handleChange(index, 'title', e.target.value)}
                    placeholder="e.g. Design Iterations"
                  />
                </div>
                <div className="space-y-2">
                  <Label>Step Description <span className="text-red-500">*</span></Label>
                  <textarea
                    className={`w-full h-32 px-4 py-2 rounded-2xl border focus:ring-2 focus:ring-primary/20 focus:border-primary outline-none transition-all text-sm ${(!item.description && submitted) ? "border-red-500" : "border-slate-200"}`}
                    value={item.description}
                    onChange={(e) => handleChange(index, 'description', e.target.value)}
                    placeholder="Describe what was built/implemented..."
                  />
                </div>
              </div>

              <div className={(!item.image && submitted) ? "rounded-2xl border-2 border-dashed border-red-300 p-1" : ""}>
                <ImageUpload
                  label={<span>Step Image <span className="font-normal text-xs text-gray-400">(1500 × 1125 px)</span> <span className="text-red-500">*</span></span>}
                  value={item.image}
                  onChange={(url) => handleChange(index, 'image', url)}
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BuiltForm;
